import { Injectable } from "@angular/core";
import { EncryptDecryptService } from "./encrypt-decrypt.service";
import { HomeDetailService } from "src/app/core/services/home-detail.service";
@Injectable({
  providedIn: "root",
})
export class DataservicesService {
  constructor(
    private encrdecrService: EncryptDecryptService,
    public homeService: HomeDetailService
  ) {}
  public msg: string;
  public homeDetail: any = {};
  public title: string;
  public isConfirmation: boolean;
  public regId: string;
  public percentage: number;
  public username: string;
  public guardianEmail: string;
  private Guid = "0ef1705aff564c319643a287081d7b8d";
  add(
    title: string,
    message: string,
    regId?,
    percentage?,
    username?,
    isConfirmation = false,
    guardianEmail?
  ) {
    this.msg = message;
    this.title = title;
    this.regId = regId;
    this.percentage = percentage;
    this.username = username;
    this.isConfirmation = isConfirmation;
    this.guardianEmail = guardianEmail;
  }

  public EncryptValue(value): string {
    // const cipherKey = this.encrdecrService.encrypt(this.Guid, 'test');
    const cipherValue = this.encrdecrService.encrypt(this.Guid, value);
    return cipherValue;
  }

  public DecryptValue(cipherValue): string {
    // const cipherKey = this.encrdecrService.encrypt(this.Guid, 'test');
    const value = this.encrdecrService.decrypt(this.Guid, cipherValue);
    return value;
  }

  public getHomeDetail() {
    this.homeService.getHomeDetail().subscribe(
      (res: any) => {
        res.forEach((item) => {
          this.homeDetail[item.ContentName] = item;
        });
        Object.keys(this.homeDetail).forEach((key) => {
          const item = this.homeDetail[key];
          if (typeof item.ContentTitle === "string") {
            item.ContentTitle = item.ContentTitle.replace(
              /\\n/g,
              "<br>"
            ).replace(/\r\n/g, "<br>");
          }

          if (typeof item.ContentDetail === "string") {
            item.ContentDetail = item.ContentDetail.replace(
              /\\n/g,
              "<br>"
            ).replace(/\r\n/g, "<br>");
          }
          const customKey = "Home_What_Can";

          if (
            this.homeDetail[customKey] &&
            typeof this.homeDetail[customKey].ContentDetail === "string"
          ) {
            this.homeDetail[customKey].ContentDetail = this.homeDetail[
              customKey
            ].ContentDetail.replace(
              /<ul(?![^>]*class=)/, // only if no class already
              '<ul class="sv-list"'
            );
          }
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
